<template>
    <div class="europe-far-right">
        <div class="zone-title zone-title--bg banded landing__zone-title--short">
            <div class="container-title container-headline container-headline--no-image foreground">
                <h2>{{ pageData.data.title }}</h2>
                <RichTextElements :elements="pageData.data.dek" class="interactive-dek" bodyStyle="serif-large" />
            </div>
        </div>
        <div class="section">
            <div class="filters">
                <form class="clean-form far-right-radio toggle-wrapper padded-less" name="far-right-radio" id="far-right-radio" action="" method="get" enctype="multipart/form-data" autocomplete="off">
                    <fieldset>
                        <div class="control-group">
                            <label class="pub-type-label" id="euViews">
                                <span class="name">EU Integration</span>
                                <input class="checkradios" type="radio" value="euViews" name="radio-group" id="radio-euViews">
                            </label>
                            <label class="pub-type-label" id="immigration">
                                <span class="name">Migration</span>
                                <input class="checkradios" type="radio" value="immigration" name="radio-group" id="radio-immigration">
                            </label>
                            <label class="pub-type-label" id="trade">
                                <span class="name">Trade</span>
                                <input class="checkradios" type="radio" value="trade" name="radio-group" id="radio-trade">
                            </label>
                            <label class="pub-type-label" id="russia">
                                <span class="name">Ukraine and Russia</span>
                                <input class="checkradios" type="radio" value="russia" name="radio-group" id="radio-russia">
                            </label>
                            <label class="pub-type-label" id="nato">
                                <span class="name">NATO</span>
                                <input class="checkradios" type="radio" value="nato" name="radio-group" id="radio-nato">
                            </label>
                            <label class="pub-type-label" id="china">
                                <span class="name">China</span>
                                <input class="checkradios" type="radio" value="china" name="radio-group" id="radio-china">
                            </label>
                            <label class="pub-type-label" id="development">
                                <span class="name">Development Aid</span>
                                <input class="checkradios" type="radio" value="development" name="radio-group" id="radio-development">
                            </label>
                            <label class="pub-type-label" id="euEnlargement">
                                <span class="name">EU Enlargement</span>
                                <input class="checkradios" type="radio" value="euEnlargement" name="radio-group" id="radio-euEnlargement">
                            </label>
                            <label class="pub-type-label" id="climate">
                                <span class="name">Climate Change</span>
                                <input class="checkradios" type="radio" value="climate" name="radio-group" id="radio-climate">
                            </label>
                            <label class="pub-type-label" id="democracy">
                                <span class="name">Democracy and Minority Rights</span>
                                <input class="checkradios" type="radio" value="democracy" name="radio-group" id="radio-democracy">
                            </label>
                            <label class="pub-type-label" id="israelPalestine">
                                <span class="name">The Israeli-Palestinian Conflict</span>
                                <input class="checkradios" type="radio" value="israelPalestine" name="radio-group" id="radio-israelPalestine">
                            </label>
                            <label class="pub-type-label active" id="default">
                                <span class="name">Reset</span>
                                <input class="checkradios" type="radio" value="default" name="radio-group" id="radio-default">
                            </label>
                        </div>
                    </fieldset>
                </form>
            </div>
            <div class="section map">
                <div id="chartdiv"></div>
                <div id="info"></div>
                <div id="countrySelect">
                    <form class="clean-form far-right-dropdown" name="far-right-dropdown" id="far-right-dropdown" action="" method="get" enctype="multipart/form-data" autocomplete="off">
                        <select name="far-right-countries" id="far-right-countries">
                            <option value="reset">Select Country</option>
                            <option value="AT">Austria</option>
                            <option value="BG">Bulgaria</option>
                            <option value="EE">Estonia</option>
                            <option value="FI">Finland</option>
                            <option value="FR">France</option>
                            <option value="DE">Germany</option>
                            <option value="HU">Hungary</option>
                            <option value="IT">Italy</option>
                            <option value="NL">Netherlands</option>
                            <option value="PL">Poland</option>
                            <option value="RO">Romania</option>
                            <option value="SK">Slovakia</option>
                            <option value="ES">Spain</option>
                            <option value="SE">Sweden</option>
                        </select>
                    </form>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="foreground">
                <div class="learn-more">
                    <p>This study does not cover all radical-right parties across the EU. Rather, it focuses on a curated selection based on the parties’ national standings and their capacities to effectively shape their respective countries’ foreign policies.</p>
                    <p>The map’s authors are Zakaria Al Shmaly, Mattia Bagherini, and Elena Ventura. The map has been designed by Jessica Katz, Tim Martin, and Jocelyn Soly.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
useHead({
    script: [
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/index.js' },
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/map.js' },
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/geodata/region/world/europeLow.js' },
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/themes/Animated.js' },
    ],
});
import { onMounted, ref } from 'vue';
import FeatureFragment from '@fragments/pages/FeatureFragment.js';

const pageData = await usePageData(FeatureFragment, 'features');

let usedDataArray;
let responsive = false;
let mobile = false;

// does this need to happen any time other than on load?  We could repeat with each button, just not sure it's worth it ...
function getResponsive() {
    const windowWidth = ref(window.innerWidth);
    if (windowWidth.value <= 767) {
        mobile = true;
    } else if (windowWidth.value <= 1024) {
        responsive = true;
    }
}
// anything that needs the DOM to exist (like calling document or window) has to be called here
let trackedCountry = "#e6e7e8";
let inactiveCountry = "#e6e7e8";
let clickedCountry = "#003a63";
let activeCountryDefault = "#5E83AA";
let activeCountryEuViews = "#00a79d";
let activeCountryImmigration = "#3183b1";
let activeCountryTrade = "#bb9764";
let activeCountryRussia = "#27aae1";
let activeCountryNato = "#ef4136";
let activeCountryChina = "#fbb040";
let activeCountryDevelopment = "#812160";
let activeCountryEuEnlargement = "#6e6e71";
let activeCountryClimate = "#338f4a";
let activeCountryDemocracy = "#1c4c49";
let activeCountryIsraelPalestine = "#89684f";

onMounted(() => {
    trackedCountry = am5.color(0xe6e7e8);
    inactiveCountry = am5.color(0xe6e7e8);
    clickedCountry = am5.color(0x003a63);
    getResponsive();
    callMap();
});

let dataArray = [
	{
	id: "AT",
	arrayItem: true,
	country: "Austria",
	title:
		"<div class='description'><p><strong>Party Name</strong> Freedom Party of Austria (FPÖ)</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>1956</p><p><strong>Summary</strong>Under the slogan “Austria First,” the deeply Euroskeptic Freedom Party of Austria (FPÖ) opposes multiculturalism, globalization, and mass immigration and focuses on preserving Austrian neutrality and protecting the country’s identity.</p><p><strong>Electoral Influence</strong>Ahead of the Austrian parliamentary election scheduled for fall 2024, the FPÖ leads the polls with up to 30 percent of the vote.</p><p><strong>Political Group Affiliation in the European Parliament</strong>Identity and Democracy</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> No longer advocates Austria’s exit from the EU but defends the sovereignty of member states.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Hostile:</span> Hostile to refugees and labor migrants, with a particular bias against migrants and asylum seekers from Muslim-majority countries.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong><span>Inconsistent:</span> Supportive of some neoliberal policies, such as tax cuts and limited government spending; opposed to EU trade agreements. </p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Pro-Russia:</span> Sympathetic to Russia’s policies and opposed to EU sanctions against Moscow; supportive of a diplomatic approach to Russia’s war in Ukraine. </p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Anti-NATO:</span> Supportive of Austria’s neutral status; sees a stronger EU role in security and defense policy as a threat.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong>This issue is not among the top priorities of the party.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong>Against any initiative aimed at increasing development aid and in favor of linking aid to cooperation on migration.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong><span>Against enlargement:</span> Opposed to EU enlargement on the grounds that new countries would receive huge EU funds and send migrants to Austria.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span> Against the green transition:</span> Critical of the European Green Deal and environmental measures proposed by the Austrian government; supportive of Austria’s continued reliance on oil and gas.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong>This issue is not among the top priorities of the party.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> Supportive of Israel’s right to build settlements in the West Bank and of moving the Austrian embassy in Israel to Jerusalem; portrays itself as philo-Semitic and pro-Israel. </p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	development: true,
	euEnlargement: true,
	climate: true,
	israelPalestine: true,
	mapData: {
		id: "AT",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "AT",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "BG",
	arrayItem: true,
	country: "Bulgaria",
	title:
		"<div class='description'><p><strong>Party Name</strong> Revival</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>2014</p><p><strong>Summary</strong>Revival is a nationalist, anti-Western, and pro-Kremlin party. Revival’s foreign policy positions have promoted Russia’s interests and stances while rejecting Bulgaria’s Euro-Atlantic commitments.</p><p><strong>Electoral influence</strong>In the 2023 Bulgarian parliamentary election, Revival secured a vote share of 13.6 percent.</p><p><strong>Political Group Affiliation in the European Parliament</strong>N/A</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Opposed to the EU, which the party sees as infringing on Bulgarian sovereignty; calls for a reformed EU based on strengthening member states’ sovereignty.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Hostile:</span> Opposed to immigration and asylum in general and to refugees from Ukraine in particular.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong><span>Against free trade:</span> Opposed to the “unfair single market” distorted by French and German subsidies; against the introduction of the euro.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Pro-Russia:</span> Sympathetic toward Russia; calls for Bulgaria’s neutrality in Russia’s war against Ukraine.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Anti-NATO:</span> Opposed to NATO; in favor of Bulgaria’s exit from the alliance.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong><span>Pro-China:</span> Sympathetic toward China and supportive of the One China principle.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong>This issue is not among the top priorities of the party.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong>This issue is not among the top priorities of the party.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong>This issue is not among the top priorities of the party.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong><span>Ethnonationalist:</span> Committed to a conservative discourse; describes pro-Western politicians as fascists; opposed to LGBTQ rights, which the party portrays as undermining majority rights.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Inconsistent:</span> Neutral on the Israel-Hamas war; known for its anti-Semitic rhetoric.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	china: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "BG",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "BG",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "EE",
	arrayItem: true,
	country: "Estonia",
	title:
		"<div class='description'><p><strong>Party Name</strong>Conservative People’s Party of Estonia (EKRE)</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>2012</p><p><strong>Summary</strong>The Conservative People’s Party of Estonia (EKRE) is a populist-right party that promotes Euroskepticism, nativism, and an anti-elite sentiment. EKRE opposes measures that would strengthen EU powers and threaten member states’ sovereignty.</p><p><strong>Electoral Influence</strong>EKRE came second in the 2023 Estonian parliamentary election, recording 16.1 percent of the vote.</p><p><strong>Political Group Affiliation in the European Parliament</strong>Identity and Democracy</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Opposed to the EU and in favor of a union of independent nation-states; rejects any EU legislation that might imperil Estonia’s existence as a nation-state.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Hostile:<span> Hostile toward migrants and focused on protecting the ethnic Estonian majority; critical of the influx of Ukrainian refugees, whom EKRE views as a threat to Estonia’s social welfare. </p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong>This issue is not among the top priorities of the party.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Anti-Russia:</span> Opposed to Russia; strongly critical of Russia’s 2022 invasion of Ukraine and supportive of aid for Ukraine.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Pro-NATO:</span> Supportive of NATO and security relations with the United States; critical of strengthening EU defense policy, which EKRE sees as potentially undermining Estonia’s security relations with the United States.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong>This issue is not among the top priorities of the party.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong>This issue is not among the top priorities of the party.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong>This issue is not among the top priorities of the party.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Inconsistent:</span> Opposed to climate change action, which the party views as a threat to Estonia’s sovereignty and the people’s autonomy; skeptical of renewable energy but supportive of shale oil and nuclear energy.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong><span> Ethnonationalist:</span> Opposed to the protection of LGBTQ rights, which EKRE sees as a tool to subject the majority to minority rule; critical of “oppressive liberal” initiatives to regulate hate speech. </p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> Supportive of Israel; advocates the recognition of Jerusalem as Israel’s capital. </p></div>",
	euViews: true,
	immigration: true,
	russia: true,
	nato: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "EE",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "EE",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "FI",
	arrayItem: true,
	country: "Finland",
	title:
		"<div class='description'><p><strong>Party Name</strong>Finns Party</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>1995</p><p><strong>Summary</strong>The Finns Party is a populist radical-right party that accuses the EU of enabling mass immigration. The party’s hard stances toward multiculturalism, climate change policies, development aid, the EU, and national defense form the core of its foreign policy agenda.</p><p><strong>Electoral Influence</strong>In the 2023 Finnish parliamentary election, the Finns Party won 20.1 percent of the vote and joined a four-party right-of-center government.</p><p><strong>Political Group Affiliation in the European Parliament</strong>European Conservatives and Reformists</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Skeptical of the EU; previously campaigned against eurozone bailouts but softened this stance because of a lack of public support.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Hostile:</span> Hostile toward migrants; advocates strict immigration controls and opposes “harmful immigration” from Muslim-majority countries. </p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong><span>Against free trade:</span> Supportive of protectionist policies and generally opposed to free-market capitalism.  </p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Anti-Russia:</span> Vocal against Russia’s 2022 invasion of Ukraine; supportive of sanctions against Moscow and in favor of aiding Ukraine. </p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Pro-NATO:</span> Critical of Finland’s decision to seek NATO membership until Russia’s 2022 invasion of Ukraine, then supportive of joining the alliance.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong><span>Anti-China:</span> Critical of China’s “increasingly aggressive foreign policy” and “despotism”; views China as a major challenge to the West and advocates a united front against it.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong> Critical of development aid and in favor of making assistance conditional on national interests.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong>Against enlargement: Strongly opposed to expanding the EU.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Inconsistent:</span> Previously supportive of renewable energy; now critical of wind power and in favor of nuclear energy; skeptical of EU climate change policies.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong>Ethnonationalist: Opposed to multiculturalism and identifies any minority not considered “truly Finnish” as a threat.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> Supportive of Israel; perceives the Israel-Hamas war primarily as a case of Hamas terrorism; emphasizes Israel’s right to self-defense.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	china: true,
	development: true,
	euEnlargement: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "FI",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "FI",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "FR",
	arrayItem: true,
	country: "France",
	title:
		"<div class='description'><p><strong>Party Name</strong>National Rally (RN)</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>1972</p><p><strong>Summary</strong>National Rally (RN) is a radical-right party with strong anti-immigration, protectionist rhetoric. RN has a long-standing aim to preserve France’s sovereignty and push back against globalization, the EU, and the transatlantic alliance.</p><p><strong>Electoral Influence</strong>In the run-up to the June 2024 European Parliament elections, RN is polling at 30 percent.</p><p><strong>Political Group Affiliation in the European Parliament</strong>Identity and Democracy</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Skeptical of the EU and the euro; previously in favor of leaving the EU but now focused on reforming it from within by creating an alliance of nations.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Hostile:</span> Hostile to immigration, particularly from Muslim-majority countries.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong><span>Against free trade:</span> Supportive of protectionist policies, especially in agriculture; opposed to international trade agreements and in favor of bilateral accords.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Inconsistent:</span> Supportive of close ties with Russia but moderated its outlook after Russia’s 2022 invasion of Ukraine; opposed to sanctions and in favor of dialogue with Moscow.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Anti-NATO:</span> Opposed to NATO; in favor of France’s exit from the alliance’s integrated military command and the renegotiation of France-U.S. military relations.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong><span>Anti-China:</span> Critical of China’s expansionist policies but insistent that France should remain neutral in the ongoing U.S.-China rivalry.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong> Critical of development aid and supportive of making it conditional on France’s national interests and using it as a tool to reduce migration.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong><span>Against enlargement:</span> Opposed to EU enlargement, which RN perceives as a threat to sovereignty and a potential catalyst for a further influx of migrants.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Inconsistent:</span> Opposed to the European Green Deal and in favor of national environmental policies; supportive of nuclear energy and critical of subsidies for solar and wind energy.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong>Ethnonationalist: Traditionally opposed to multiculturalism and minority rights but has softened its position on these issues in recent years.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> Supportive of Israel; after the October 7, 2023, Hamas attacks, RN proposed measures against those who support the group.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	china: true,
	development: true,
	euEnlargement: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "FR",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "FR",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "DE",
	arrayItem: true,
	country: "Germany",
	title:
		"<div class='description'><p><strong>Party Name</strong>Alternative for Germany (AfD)</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>2013</p><p><strong>Summary</strong>The Alternative for Germany (AfD) taps into growing public unease about European and national migration and asylum policies. The party leverages anti-Islam sentiments and criticizes the EU for interfering in Germany’s domestic affairs.</p><p><strong>Electoral Influence</strong>In the 2021 German federal election, the AfD received 10.1 percent of the vote, but its support in polling has since increased to around 20 percent.</p><p><strong>Political Group Affiliation in the European Parliament</strong>Identity and Democracy</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Skeptical of the EU and previously advocated Germany’s exit from the eurozone and, potentially, the union; later softened this stance and called for a federation of European nations.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Hostile:</span> Opposed to immigration, especially from Muslim-majority countries; in favor of expedited asylum processing and the adoption of measures to curb refugee inflows.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong><span>In favor of free trade:</span> Supportive of neoliberal policies with minimal state intervention; favorable to trade agreements if they do not undermine German safety standards; insistent on national control over the negotiation of trade deals.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Pro-Russia:</span> Opposed to EU sanctions on Russia and in favor of dialogue with Moscow.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Inconsistent:</span> Committed to distancing itself from the United States but supportive of Trump.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong><span>Inconsistent:</span> Opposed to Chinese economic activities in Germany but critical of German ministers for starting an “economic war” against China; opposed to restrictions on 5G tech and supportive of Beijing’s mediation efforts in Ukraine.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong> Supportive of the use of development aid as a policy tool to reduce migration.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong><span>Against enlargement:</span> Opposed to EU enlargement.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Against the green transition:</span> Skeptical of climate change as a man-made phenomenon; supportive of lignite mining and in favor of overturning legislation to promote renewable energy.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong><span>Ethnonationalist:</span> Committed to traditional family values and gender roles; opposed to same-sex marriage.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> Supportive of Israel; advocates recognizing Jerusalem as Israel’s capital and cutting aid to Palestinian organizations; called for the mass deportation of refugees who support Palestine, describing them as a threat to national security.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	china: true,
	development: true,
	euEnlargement: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "DE",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "DE",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "HU",
	arrayItem: true,
	country: "Hungary",
	title:
		"<div class='description'><p><strong>Party Name</strong>Fidesz</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>1988</p><p><strong>Summary</strong>Fidesz opposes efforts to increase the competencies of the EU institutions at the expense of national governments. The party supports friendly relations with Russia and China and frequently challenges the EU foreign policy mainstream.</p><p><strong>Electoral Influence</strong>Fidesz won the 2022 Hungarian parliamentary election with 54 percent of the vote, maintaining the ability to appoint key positions.</p><p><strong>Political Group Affiliation in the European Parliament</strong>Nonattached members</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Ambivalent toward EU membership; recognizes membership’s benefits but advocates the prioritization of nation-states in EU decisionmaking; depicts Brussels as trying to impose an anti-Hungarian agenda.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Hostile:</span> Hostile to refugees and labor migrants; opposed to EU asylum agreements; more supportive of Ukrainian refugees.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong><span>In favor of free trade:</span> Supportive of free trade.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Pro-Russia:</span> Sympathetic toward Russia and opposed to EU sanctions against Moscow; supportive of Ukraine’s EU membership bid in principle but was previously obstructive.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Pro-NATO:</span> Supportive of Hungary’s NATO membership and active participation in NATO missions.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong><span>Pro-China:</span> Supportive of long-term relationships with China through participation in the Belt and Road Initiative; believes China offers opportunities; has vetoed EU declarations critical of Beijing.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong> Skeptical of EU aid programs; has shifted resources to Hungary’s bilateral assistance programs.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong><span>In favor of enlargement:</span> Supportive of EU enlargement; seeks to leverage ethnic Hungarian populations in neighboring countries for influence.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Inconsistent:</span> Critical of EU climate change policies; focuses on energy security by prioritizing gas-fired power plants and nuclear energy.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong><span>Ethnonationalist:</span> In favor of using EU neighborhood policies to support Hungarian minorities and leverage EU enlargement for Hungarian interests.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> Supportive of Israel’s government, especially under Netanyahu, and its right to self-defense after the October 7, 2023, Hamas attacks.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	china: true,
	development: true,
	euEnlargement: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "HU",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "HU",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "IT",
	arrayItem: true,
	country: "Italy",
	title:
		"<div class='description'><p><strong>Party Name</strong>Brothers of Italy (FdI)</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>2012</p><p><strong>Summary</strong>Brothers of Italy (FdI) has strong ideological roots in Italy’s fascist movement and is anchored in the motto “God, Fatherland, and Family.” FdI rejects any further strengthening of the EU’s powers and any perspective of a federalized union.</p><p><strong>Electoral Influence</strong>In the 2022 Italian parliamentary election, FdI became the leading political party after achieving 26.1 percent of the vote.</p><p><strong>Political Group Affiliation in the European Parliament</strong>European Conservatives and Reformists</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Skeptical of the EU but does not advocate Italy’s exit from the EU or the eurozone; opposed to federalization and in favor of a confederation of sovereign states based on traditional and Christian values.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Inconsistent/ambiguous:</span> Opposed to immigration, especially from Muslim-majority countries; in favor of strict immigration controls; supportive of labor migration when in Italy’s national interests.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong>In favor of free trade: On entering government, became more supportive of free trade and developed a particular interest in strengthening economic relations with the Southern Mediterranean and North Africa.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Anti-Russia:</span> Sympathetic toward Russia until its 2022 invasion of Ukraine; then distanced itself from Moscow and adopted a strong stance in support of Ukraine, backing sanctions against Moscow and military support to Kyiv.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Pro-NATO:</span> Supportive of NATO; aims to strengthen Italy’s role in the alliance and advocates increased national spending on security and defense.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong><span>Anti-China:</span> Hostile to China but softened its stance upon coming into government; withdrew from the Belt and Road Initiative and often advocated dialogue with Taiwan.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong> Supportive of development aid as a tool to reduce migration and strengthen Italy’s positioning in the Mediterranean.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><p><strong>EU Enlargement</strong><span>In favor of enlargement:</span> Supportive of EU enlargement to the Western Balkans; committed to support Ukraine, including by backing the country’s EU membership bid.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Inconsistent:</span> Skeptical of climate change as a key policy area; advocates reducing Italy’s dependence on Russian energy and diversifying energy sources, including with renewables.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong><span>Ethnonationalist:</span> Committed to traditional values, as exemplified by FdI’s slogan of “God, Fatherland, and Family.”</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> Supportive of Israel after the October 7, 2023, Hamas attacks; sees the conflict as a threat to Italy’s national security that may lead to increased irregular migration and further radicalization.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	china: true,
	development: true,
	euEnlargement: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "IT",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "IT",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "NL",
	arrayItem: true,
	country: "Netherlands",
	title:
		"<div class='description'><p><strong>Party Name</strong>Party for Freedom (PVV)</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>2006</p><p><strong>Summary</strong>The Party for Freedom (PVV) has exploited Islamophobia to promote restrictive immigration policies. The PVV prioritizes national interests and has in the past advocated the Netherlands’ withdrawal from the EU and the eurozone.</p><p><strong>Electoral Influence</strong>In the 2023 Dutch parliamentary election, the PVV became the largest party in the parliament with 23.5 percent of the vote and entered coalition talks.</p><p><strong>Political Group Affiliation in the European Parliament</strong>N/A</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Critical of EU membership; advocates a referendum on the Netherlands’ EU exit; opposed to further EU policies on enlargement, immigration, and asylum.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Hostile:</span> Supportive of stricter controls on asylum seekers, especially from Muslim-majority countries; opposed to the EU’s asylum policy and burden sharing.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong><span>Inconsistent:</span> Supportive of national interests in trade policies, arguing that the Netherlands should limit its involvement with the EU to trade treaties.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Inconsistent:</span> Initially critical of Russia but later praised Putin as an ally against Muslim immigration; after Russia’s 2022 invasion of Ukraine, condemned Russia and supported Ukraine.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong>Inconsistent: Supportive of stronger relations with the United States; but after Russia’s invasion of Ukraine, critical of NATO for its expansion plans, which the party labeled “irresponsible provocations toward Russia.”</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong>Anti-China: Opposed to China’s expansionist policies; calls for the safeguarding of Dutch national interests, particularly on security matters and trade relations with Beijing.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong> Supportive of development aid only if it is in the Netherlands’ best interests.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong><span>Against enlargement:</span> Opposed to further EU enlargement.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Inconsistent:</span> Neutral toward climate change policies but wants the Netherlands to withdraw from the Paris Agreement and rejects EU regulations in this area.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong>Ethnonationalist: Opposed to multiculturalism and well-known for its Islamophobic rhetoric; has advocated the closure of mosques and threatened fundamental freedoms, such as the freedom of religion and expression.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> In favor of the construction of Jewish villages in the West Bank; wants to move the Dutch embassy in Israel to Jerusalem and close the Dutch representative office in Ramallah.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	china: true,
	development: true,
	euEnlargement: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "NL",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "NL",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "PL",
	arrayItem: true,
	country: "Poland",
	title:
		"<div class='description'><p><strong>Party Name</strong>Law and Justice (PiS)</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>2001</p><p><strong>Summary</strong>Law and Justice (PiS) is a right-wing populist and national-conservative party that has shifted toward an increasingly negative attitude to European integration. PiS emphasizes the importance of hard security, energy independence, and the primacy of national law.</p><p><strong>Electoral Influence</strong>After almost a decade in power, PiS received 35.4 percent of the vote in the 2023 Polish parliamentary election but lacked coalition partners to form a government.</p><p><strong>Political Group Affiliation in the European Parliament</strong>European Conservatives and Reformists</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Opposed to further European integration; aims to safeguard Poland’s sovereignty and rejects an EU federation that would diminish the role of member states.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Inconsistent/ambiguous:</span> Hostile to immigration, especially from Muslim-majority countries; welcomed Ukrainian refugees; opposed to EU asylum mechanisms.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong>In favor of free trade: Overall supportive of free trade while maintaining a protectionist stance over Ukrainian grain imports, aimed at protecting Poland’s agricultural sector.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Anti-Russia:</span> Supportive of Ukraine after Russia’s 2022 invasion and provided military supplies; critical of Poland’s Western partners for allowing Russia to invade Ukraine.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Pro-NATO:</span> Supportive of NATO; emphasizes its importance for European security and advocates closer EU-NATO cooperation; committed to increased defense spending.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong>Anti-China: Opposed to China, which the party labels a systemic rival, and aligned with the United States in its competition with China; strongly critical of Beijing’s ambiguous position on Russia’s war in Ukraine.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong> Supportive of the use of development aid as a tool to reduce migration.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong><span>In favor of enlargement:</span> Supportive of EU enlargement to Eastern Europe and the Western Balkans; views enlargement as part of a national security strategy against Russia.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Inconsistent:</span> Hesitant about the European Green Deal; advocates a transition from coal to gas, renewable energy, and nuclear power; views climate policy in relation to security vis-à-vis Russia.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong><span>Ethnonationalist:</span> Supportive of democracy as an expression of majority rule in a nation-state.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> Supportive of Israel, especially the ruling Likud party; condemned the October 7, 2023, Hamas attacks while trying to link the conflict to anti-Islam views.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	china: true,
	development: true,
	euEnlargement: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "PL",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "PL",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "RO",
	arrayItem: true,
	country: "Romania",
	title:
		"<div class='description'><p><strong>Party Name</strong>Alliance for the Unity of Romanians (AUR)</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>2019</p><p><strong>Summary</strong>The Alliance for the Union of Romanians (AUR) revolves around four essential values: Christian faith, freedom, family, and the nation. AUR does not promote an anti-European agenda but frequently challenges decisions made by the EU institutions.</p><p><strong>Electoral Influence</strong>Ahead of the 2024 Romanian parliamentary election, scheduled for December, AUR is polling at around 19 percent.</p><p><strong>Political Group Affiliation in the European Parliament</strong>N/A</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Opposed to the EU; in favor of safeguarding national sovereignty and creating a Europe of nations.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Hostile:</span> Critical of international organizations’ decisions on migrants and seeks to renationalize decisionmaking; against attracting foreign labor and integrating Ukrainian refugees, except ethnic Romanians.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong><span>Against free trade:</span> Committed to protectionism and economic nationalism; believes Romania should exploit its natural wealth for the benefit of Romanians; argues the country is disadvantaged in international trade.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Inconsistent:</span> Opposed to Putin and supportive of sanctions on Russia but believes aid to Ukraine should be conditional on protecting the rights of Ukraine’s ethnic Romanian minority.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Pro-NATO:</span> Supportive of Romania’s membership in NATO, which AUR considers the only guarantor of Romania’s and Europe’s security; believes Romania should negotiate a better role in the alliance.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong>This issue is not among the top priorities of the party.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong> This issue is not among the top priorities of the party.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong><span>Inconsistent:</span> Supportive of Moldova’s integration into a reformed EU; vague, opportunistic, and often nationalistic in its stance on EU enlargement to other states, especially Ukraine.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Against the green transition:</span> Committed to securing energy independence by restoring fossil-fuel production and nationalizing Black Sea gas reserves; considers the European Green Deal a dictatorial measure; opposed to EU interference in energy supply decisions.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong><span>Ethnonationalist:</span> Opposed to democratic rights when these threaten the Christian, white, and native majority; against European initiatives on sexual minority rights and freedom of religion.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Inconsistent:</span> Officially boycotted by Israel because of AUR’s history of anti-Semitism; yet meetings between AUR’s leader and Israel’s ambassador to Romania occurred before the October 7, 2023, Hamas attacks.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	euEnlargement: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "RO",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "RO",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "SK",
	arrayItem: true,
	country: "Slovakia",
	title:
		"<div class='description'><p><strong>Party Name</strong>Slovak National Party (SNS)</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>1990</p><p><strong>Summary</strong>The Slovak National Party (SNS) is a nationalist, right-wing party with a pro-Russia stance. The SNS’s criticism of the EU focuses on resisting the union’s perceived centralizing tendencies, especially regarding migration policy, and on protecting Slovakia’s sovereignty.</p><p><strong>Electoral Influence</strong>In the 2023 Slovak parliamentary election, SNS received 5.6 percent of the vote.</p><p><strong>Political Group Affiliation in the European Parliament</strong>N/A</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Supportive of reforming the EU to safeguard member states’ sovereignty; focused on protecting Slovakia’s veto rights and furthering its negotiating power in relation to big member states.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Inconsistent/ambiguous:</span> Opposed to migration on religious and ethnic grounds; more favorable toward Ukrainian refugees because of their cultural affinity and ability to integrate into the Slovak labor market.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong>This issue is not among the top priorities of the party.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Pro-Russia:</span> Supportive of Russia; refrained from labeling the country the aggressor in the war in Ukraine; critical of EU sanctions on Russia and campaigned to stop weapons supplies to Ukraine.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Inconsistent:</span> Committed to fulfilling Slovakia’s NATO obligations while calling for improvements in the way the alliance works.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong>This issue is not among the top priorities of the party.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong>This issue is not among the top priorities of the party.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong>This issue is not among the top priorities of the party.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Against the green transition:</span> Skeptical of climate change; in favor of renewing cheap fossil-fuel supplies from Russia; critical of overly strict environmental regulations.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong><span>Ethnonationalist:</span> Focused on protecting the Slovak nation and uniting with neighbors to counter Brussels; has used anti-Hungarian, anti-Roma, and anti-LGBTQ rhetoric to mobilize voters.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Inconsistent:</span> Supportive of Israel but has remained silent since the October 7, 2023, Hamas attacks.</p></div>",
	euViews: true,
	immigration: true,
	russia: true,
	nato: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "SK",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "SK",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "ES",
	arrayItem: true,
	country: "Spain",
	title:
		"<div class='description'><p><strong>Party Name</strong>Vox</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>2013</p><p><strong>Summary</strong>Vox presents itself as the defender of Spain’s national interests and advocates a new EU treaty to safeguard member states’ sovereignty. The party has a strong anti-immigration stance.</p><p><strong>Electoral Influence</strong>Vox gained 12.4 percent of the vote in the 2023 Spanish parliamentary election, down from 15 percent in 2019.</p><p><strong>Political Group Affiliation in the European Parliament</strong>European Conservatives and Reformists</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Skeptical of the EU but does not advocate Spain’s exit from the EU or the eurozone; in favor of a new EU treaty to keep the member states at the forefront of decisionmaking.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Hostile:</span> Opposed to immigration and in favor of the repatriation of unaccompanied foreign minors and migrants who enter Spain illegally; calls for military deployments to prevent migrant arrivals.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong><span>Inconsistent:</span> Committed to neoliberal policies and in favor of lower taxes; maintains antiglobalist views with protectionist overtones.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Anti-Russia:</span> Opposed to Russia’s 2022 invasion of Ukraine and supportive of military aid to Kyiv.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong>This issue is not among the top priorities of the party.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong>This issue is not among the top priorities of the party.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong>Supportive of the use of development aid as a policy tool to reduce migration.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong>This issue is not among the top priorities of the party.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Against the green transition:</span> Skeptical of climate change, often questioning its scientific validity; opposed to climate policies imposed by the UN and the EU, viewing them as threats to Spanish sovereignty.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong><span> Ethnonationalist:</span> Committed to traditional and conservative values; opposed to “gender ideologies,” feminism, and legislation to uphold LGBTQ rights.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> In favor of halting aid to Palestine, arguing that some NGOs that receive Spanish aid are linked to Hamas; views support for Israel as part of a broader campaign against Islamist extremism and migration.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	development: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "ES",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "ES",
		settings: { fill: inactiveCountry },
	},
	},
	{
	id: "SE",
	arrayItem: true,
	country: "Sweden",
	title:
		"<div class='description'<p><strong>Party Name</strong>Sweden Democrats (SD)</p></div>",
	description:
		"<div class='description'><p><strong>Year of Foundation</strong>1988</p><p><strong>Summary</strong>The Sweden Democrats (SD) are a radical-right party with a strong emphasis on preserving Swedish identity and heritage. The SD is socially conservative, advocates traditional values, and opposes multiculturalism.</p><p><strong>Electoral Influence</strong>Since September 2022, the SD has been the second-biggest party in the Swedish parliament after winning over 20 percent of the vote.</p><p><strong>Political Group Affiliation in the European Parliament</strong>European Conservatives and Reformists</p></div>",
	euViewsDescription:
		"<div class='description'><p><strong>EU Integration</strong><span>Euroskeptic:</span> Previously supportive of Sweden’s exit from the union; has since softened its position but continues to oppose further European integration.</p></div>",
	immigrationDescription:
		"<div class='description'><p><strong>Migration</strong><span>Inconsistent/ambiguous:</span> Supportive of much lower non-EU migration, especially of refugees and labor migrants from Muslim-majority countries; supportive of Ukrainians’ entry into the EU.</p></div>",
	tradeDescription:
		"<div class='description'><p><strong>Trade</strong><span>In favor of free trade:</span> Supportive of free trade and in favor of the EU’s transformation into a trade-based union; since fall 2022, the SD has supported a governing coalition of pro–free trade parties.</p></div>",
	russiaDescription:
		"<div class='description'><p><strong>Ukraine and Russia</strong><span>Anti-Russia:</span> Hostile toward Russia.</p></div>",
	natoDescription:
		"<div class='description'><p><strong>NATO</strong><span>Inconsistent:</span> Opposed to NATO membership until Russia’s 2022 invasion of Ukraine; argued that Sweden should join NATO only if Finland did the same.</p></div>",
	chinaDescription:
		"<div class='description'><p><strong>China</strong>This issue is not among the top priorities of the party.</p></div>",
	developmentDescription:
		"<div class='description'><p><strong>Development Aid</strong> Supportive of reducing Swedish development aid; proposed aligning aid with migration considerations and leveraging aid to promote national interests.</p></div>",
	euEnlargementDescription:
		"<div class='description'><p><strong>EU Enlargement</strong><span>Against enlargement:</span> Hostile to EU enlargement, citing economic challenges and new member states’ limited capacity to control their borders.</p></div>",
	climateDescription:
		"<div class='description'><p><strong>Climate Change</strong><span>Against the green transition:</span> Dismissive of climate change concerns on the basis of Sweden’s small carbon footprint; opposed to fuel taxes and climate change demands in EU-China trade talks.</p></div>",
	democracyDescription:
		"<div class='description'><p><strong>Democracy and Minority Rights</strong><span>Inconsistent:</span> Opposed to multiculturalism but moderated some of its views, for example by supporting same-sex marriage.</p></div>",
	israelPalestineDescription:
		"<div class='description'><p><strong>The Israeli-Palestinian Conflict</strong><span>Pro-Israel:</span> Supportive of Israel and in favor of Jerusalem as Israel’s capital; advocated expelling from Sweden those who supported Hamas after the October 7, 2023, attacks.</p></div>",
	euViews: true,
	immigration: true,
	trade: true,
	russia: true,
	nato: true,
	development: true,
	euEnlargement: true,
	climate: true,
	democracy: true,
	israelPalestine: true,
	mapData: {
		id: "SE",
		settings: { fill: trackedCountry },
	},
	inactiveMapData: {
		id: "SE",
		settings: { fill: inactiveCountry },
	},
	},
];

let mapDataArray = dataArray;


function significantMotivationInput(event) {
    motivationFilter('significant');
    changeButtonOnClick(event);
}

function callMap() {	
	// Create root element
	// https://www.amcharts.com/docs/v5/getting-started/#Root_element
	let root = am5.Root.new("chartdiv");

	// Set themes
	// https://www.amcharts.com/docs/v5/concepts/themes/
	root.setThemes([
		am5themes_Animated.new(root)
	]);

	// Create the map chart
	// https://www.amcharts.com/docs/v5/charts/map-chart/
	let chart = root.container.children.push(
		am5map.MapChart.new(root, {
			panX: "none",
			panY: "none",
			wheelX: "none",
			wheelY: "none",
			projection: am5map.geoEqualEarth()
		})
		);
		
	// adding the zoom controls and making them dark blue    
	const zoomControl = chart.set("zoomControl", am5map.ZoomControl.new(root, {}));
	const zoomButtons = ['minusButton', 'plusButton'];

	zoomButtons.forEach((button) => {
		zoomControl[button].get('background').setAll({
			fill: am5.color("#072a42")
		});
		zoomControl[button].get('background').states.create('hover', {}).setAll({
			fill: am5.color(0x000000)
		});
		zoomControl[button].get('background').states.create('down', {}).setAll({
			fill: am5.color(0x00a79d)
		});
	});

	// Create series for background fill
	// https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/#Background_polygon
	let backgroundSeries = chart.series.push(am5map.MapPolygonSeries.new(root, {}));
	backgroundSeries.mapPolygons.template.setAll({
		fill: am5.color("#BFD7E1"),
		fillOpacity: 1,
		strokeOpacity: 0
	});

	// Add background polygon
	// https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/#Background_polygon
	backgroundSeries.data.push({
		geometry: am5map.getGeoRectangle(73, 45, 30, -13)
	});

	// Create main polygon series for countries
	// https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/
	let polygonSeries = chart.series.push(
		am5map.MapPolygonSeries.new(root, {
			geoJSON: am5geodata_region_world_europeLow,
			exclude: ["SJ", "IS","GE","AM","AZ"]
		})
		);

	//country list country code
	let countryAbbreviations = ["AT", "BG", "EE", "FI", "FR", "DE", "HU", "IT", "NL", "PL", "RO", "SK", "ES", "SE"]

	// Configure series
	polygonSeries.mapPolygons.template.setAll({
		tooltipText: "{name}",
		interactive: true,
		fill: am5.color("#ffffff"),
		templateField: "settings",
		strokeWidth: 1,
	});

	polygonSeries.events.on("datavalidated", function () {
		chart.goHome();
	});

	polygonSeries.mapPolygons.template.states.create("active", {
		fill: clickedCountry
	});

	document.getElementById("far-right-countries").onchange = function (ev) { changeCountry(ev) };

	let clickedFilter = "default";

	function changeCountry(ev) {
		let results = ev.target.value;
		let info = document.getElementById("info");
		let html = "";
		// only look into the prefiltered version -- we are also using this so certain actions (activating info box, activating country, filtering table) only happen for a 'positive' result
		for (let e in mapDataArray) {
			if (mapDataArray[e].id == results) {
				// making info box visible
				document.getElementById("info").classList.add("active");

				//gathering data
				html += "<h3 class='country'>" + mapDataArray[e].country + "</h3>";
				if (mapDataArray[e].description) {
					html += mapDataArray[e].title;
					if (clickedFilter == "default") {
						html += mapDataArray[e].description;
					}
					else if (clickedFilter == "euViews") {
						html += mapDataArray[e].euViewsDescription;
					}
					else if (clickedFilter == "immigration") {
						html += mapDataArray[e].immigrationDescription;
					}
					else if (clickedFilter == "trade") {
						html += mapDataArray[e].tradeDescription;
					}
					else if (clickedFilter == "russia") {
						html += mapDataArray[e].russiaDescription;
					}
					else if (clickedFilter == "nato") {
						html += mapDataArray[e].natoDescription;
					}
					else if (clickedFilter == "china") {
						html += mapDataArray[e].chinaDescription;
					}
					else if (clickedFilter == "development") {
						html += mapDataArray[e].developmentDescription;
					}
					else if (clickedFilter == "euEnlargement") {
						html += mapDataArray[e].euEnlargementDescription;
					}
					else if (clickedFilter == "climate") {
						html += mapDataArray[e].climateDescription;
					}
					else if (clickedFilter == "democracy") {
						html += mapDataArray[e].democracyDescription;
					}
					else if (clickedFilter == "israelPalestine") {
						html += mapDataArray[e].israelPalestineDescription;
					}
				}
				else {
					html += "<div class='description'><p><strong><i>No description provided.</i></p></div>";
				}

				// making clicked country active color
				countryAbbreviations.forEach(value => {
					let countryDataItem = polygonSeries.getDataItemById(value);
					let polygon = countryDataItem.get("mapPolygon");
					if (value !== results) { polygon.states.apply("default"); }
					else { polygon.states.apply("active"); }
				});
			}
		}
		info.innerHTML = html;
	}

	polygonSeries.mapPolygons.template.events.on("click", function (ev) {
		let data = ev.target.dataItem.dataContext;
		let info = document.getElementById("info");
		let html = "";
		// only look into the prefiltered version -- we are also using this so certain actions (activating info box, activating country, filtering table) only happen for a 'positive' result
		for (let e in mapDataArray) {
			if (mapDataArray[e].country == data.name) {
				// making info box visible
				document.getElementById("info").classList.add("active");

				//gathering data
				html += "<h3 class='country'>" + mapDataArray[e].country + "</h3>";
				if (mapDataArray[e].description) {
					html += mapDataArray[e].title;
					if (clickedFilter == "default") {
						html += mapDataArray[e].description;
					}
					else if  (clickedFilter == "euViews") {
						html += mapDataArray[e].euViewsDescription;
					}
					else if (clickedFilter == "immigration") {
						html += mapDataArray[e].immigrationDescription;
					}
					else if (clickedFilter == "trade") {
						html += mapDataArray[e].tradeDescription;
					}
					else if (clickedFilter == "russia") {
						html += mapDataArray[e].russiaDescription;
					}
					else if (clickedFilter == "nato") {
						html += mapDataArray[e].natoDescription;
					}
					else if (clickedFilter == "china") {
						html += mapDataArray[e].chinaDescription;
					}
					else if (clickedFilter == "development") {
						html += mapDataArray[e].developmentDescription;
					}
					else if (clickedFilter == "euEnlargement") {
						html += mapDataArray[e].euEnlargementDescription;
					}
					else if (clickedFilter == "climate") {
						html += mapDataArray[e].climateDescription;
					}
					else if (clickedFilter == "democracy") {
						html += mapDataArray[e].democracyDescription;
					}
					else if (clickedFilter == "israelPalestine") {
						html += mapDataArray[e].israelPalestineDescription;
					}
				}
				else {
					html += "<div class='description'><p><strong><i>No description provided.</i></p></div>";
				}

				// making clicked country active color
				countryAbbreviations.forEach(value => {
					let countryDataItem = polygonSeries.getDataItemById(value);
					let polygon = countryDataItem.get("mapPolygon");
					if (value !== data.id) { polygon.states.apply("default"); }
					else { polygon.states.apply("active"); }
				});
			}
		}
		info.innerHTML = html;
	});

	//reconfigure based on filters

	function buildMapFromButton(inactiveResults, results, value) {
		// create array that is only the negative results inactiveMapData
		let inactiveMapDataArray = [];
		let index = 0;
		for (let e in inactiveResults) {
			inactiveMapDataArray[index] = inactiveResults[e].inactiveMapData;
			index++
		};
		let fillColor = trackedCountry
		if (value == "default") { fillColor = activeCountryDefault }
		else if (value == "euViews") { fillColor = activeCountryEuViews }
		else if (value == "immigration") { fillColor = activeCountryImmigration }
		else if (value == "trade") { fillColor = activeCountryTrade }
		else if (value == "russia") { fillColor = activeCountryRussia }
		else if (value == "nato") { fillColor = activeCountryNato }
		else if (value == "china") { fillColor = activeCountryChina }
		else if (value == "development") { fillColor = activeCountryDevelopment }
		else if (value == "euEnlargement") { fillColor = activeCountryEuEnlargement }
		else if (value == "climate") { fillColor = activeCountryClimate }
		else if (value == "democracy") { fillColor = activeCountryDemocracy }
		else if (value == "israelPalestine") { fillColor = activeCountryIsraelPalestine }
		// push to new polygonSeries the array with positive results as normal
		let activeMapColors = []
		for (let e in results) {
			activeMapColors.push(results[e].mapData);
		}
		for (let e in activeMapColors) {
			activeMapColors[e].settings.fill = fillColor;
		}
		// combine the inactive array for light color inactive countries and active array for bright active countries
		const fullMap = inactiveMapDataArray.concat(activeMapColors);
		polygonSeries.data.setAll(fullMap);
	}

	
	//Views on the EU
	document.querySelector("#radio-euViews").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.euViews);
		let inactiveResults = dataArray.filter(data => !data.euViews);
		buildMapFromButton(inactiveResults, results, "euViews");
		clickedFilter = "euViews";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='euViews'>EU Integration</h3><div class='description'><p>Some radical-right parties oppose EU integration in principle, while others accept it in certain areas that align with national interests. All of the parties are vocal in demanding that EU decisionmaking protects member states’ sovereignty.</p></div>";
	};
	//immigration
	document.querySelector("#radio-immigration").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.immigration);
		let inactiveResults = dataArray.filter(data => !data.immigration);
		buildMapFromButton(inactiveResults, results, "immigration");
		clickedFilter = "immigration";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='immigration'>Migration</h3><div class='description'><p>Most radical-right parties are hostile to EU asylum policies and to all foreigners, including labor migrants and refugees. Some parties oppose asylum seekers from Muslim-majority countries but welcome Ukrainian asylum seekers.</p></div>";
	};
	//Trade
	document.querySelector("#radio-trade").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.trade);
		let inactiveResults = dataArray.filter(data => !data.trade);
		buildMapFromButton(inactiveResults, results, "trade");
		clickedFilter = "trade";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='trade'>Trade</h3><div class='description'><p>Some radical-right parties support free trade as a driver of economic growth. However, most parties have inconsistent positions or hold protectionist views.</p></div>";
	};
	//Russia
	document.querySelector("#radio-russia").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.russia);
		let inactiveResults = dataArray.filter(data => !data.russia);
		buildMapFromButton(inactiveResults, results, "russia");
		clickedFilter = "russia";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='russia'>Ukraine and Russia</h3><div class='description'><p>Most radical-right parties align with their national government’s position of condemning Russia. Some parties moved from a Russia-friendly outlook to condemnation of Moscow’s 2022 invasion of Ukraine while maintaining a critical stance toward the EU. A third group is openly sympathetic toward Russia and opposes sanctions and military support for Ukraine.</p></div>";
	};
	//NATO
	document.querySelector("#radio-nato").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.nato);
		let inactiveResults = dataArray.filter(data => !data.nato);
		buildMapFromButton(inactiveResults, results, "nato");
		clickedFilter = "nato";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='nato'>NATO</h3><div class='description'><p>Most radical-right parties align with their national government’s position on NATO and support the transatlantic alliance. Anti-NATO sentiment is less common and is usually tied to broader antiglobalist or sovereigntist ideologies.</p></div>";
	};

	//China
	document.querySelector("#radio-china").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.china);
		let inactiveResults = dataArray.filter(data => !data.china);
		buildMapFromButton(inactiveResults, results, "china");
		clickedFilter = "china";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='china'>China</h3><div class='description'><p>Most radical-right parties—except Fidesz and Revival—are skeptical toward China. Some of the parties have avoided taking a side in the U.S.-China competition.</p></div>";
	};

	//Development Aid
	document.querySelector("#radio-development").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.development);
		let inactiveResults = dataArray.filter(data => !data.development);
		buildMapFromButton(inactiveResults, results, "development");
		clickedFilter = "development";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='development'>Development Aid</h3><div class='description'<p>Most radical-right parties have a transactional approach to aid, supporting it as leverage to reduce migration flows.</p></div>";
	};

	//EU Enlargement
	document.querySelector("#radio-euEnlargement").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.euEnlargement);
		let inactiveResults = dataArray.filter(data => !data.euEnlargement);
		buildMapFromButton(inactiveResults, results, "euEnlargement");
		clickedFilter = "euEnlargement";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='euEnlargement'>EU Enlargement</h3><div class='description'><p>Most radical-right parties see enlargement critically and consider it costly and potentially conducive to more migration. Some parties support particular candidate countries because of historical ties or national interests.</p></div>";
	};

	//Climate
	document.querySelector("#radio-climate").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.climate);
		let inactiveResults = dataArray.filter(data => !data.climate);
		buildMapFromButton(inactiveResults, results, "climate");
		clickedFilter = "climate";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='climate'>Climate Change</h3><div class='description'><p>Almost no radical-right parties deny climate change in principle. However, some of them oppose the EU’s European Green Deal and are critical of overly strict environmental policies while focusing on securing energy independence.</p></div>";
	};

	//Democracy
	document.querySelector("#radio-democracy").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.democracy);
		let inactiveResults = dataArray.filter(data => !data.democracy);
		buildMapFromButton(inactiveResults, results, "democracy");
		clickedFilter = "democracy";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='democracy'>Democracy and Minority Rights</h3><div class='description'><p>Most radical-right parties are critical of liberal democratic principles and minority rights, as they are committed to traditional and conservative values. Some parties moderated their positions to increase public support, while others maintain stricter positions, especially on same-sex marriage.</p></div>";
	};

	//Israel-Palestine
	document.querySelector("#radio-israelPalestine").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.israelPalestine);
		let inactiveResults = dataArray.filter(data => !data.israelPalestine);
		buildMapFromButton(inactiveResults, results, "israelPalestine");
		clickedFilter = "israelPalestine";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='israelPalestine'>The Israeli-Palestinian Conflict</h3><div class='description'><p>The radical-right parties are almost unanimous in perceiving Israel as a frontline state against jihadist terrorism. This position resonates with the parties’ domestic policies against immigration and multiculturalism. In some cases, anti-Semitic sentiments coexist paradoxically with a pro-Israel position.</p></div>";
	};

	//reset
	document.querySelector("#radio-default").onclick = function (e) {
		//create array with positive results
		const results = dataArray.filter(data => data.arrayItem);
		let inactiveResults = dataArray.filter(data => !data.arrayItem);
		buildMapFromButton(inactiveResults, results, "default");
		clickedFilter = "default";
		//info box
		let info = document.getElementById("info");
		info.classList.add("active");
		info.innerHTML = "<h3 class='default'>Rise of the Radical Right</h3><div class='description'><p>Despite embracing democracy, radical-right parties pose a significant challenge to the EU’s fundamental values. European leaders and institutions must address this challenge to safeguard democracy in the EU and ensure a more effective foreign policy.</p></div>";
	};

	// default load 
	//create array with positive results
	const results = dataArray.filter(data => data.arrayItem);
	let inactiveResults = dataArray.filter(data => !data.arrayItem);
	buildMapFromButton(inactiveResults, results, "default");
	//info box
	let info = document.getElementById("info");
	info.classList.add("active");
	info.innerHTML = "<h3 class='default'>Rise of the Radical Right</h3><div class='description'><p>Despite embracing democracy, radical-right parties pose a significant challenge to the EU’s fundamental values. European leaders and institutions must address this challenge to safeguard democracy in the EU and ensure a more effective foreign policy.</p></div>";


	// Make stuff animate on load
	chart.appear(1000, 100);
};
</script>

<style lang="scss" scoped>
.europe-far-right {
	
	/* layout */
	$gutter: 30px;
	$site-width: 1000px;

	$primary-light-blue: #3183b1;
	$primary-dark-blue: #072a42;
	$active-teal: #00A79D;
	$active-selected: #00AEEF; //3183b1
	$medium-gray: #e6e7e8;
	$black: #000;
	$white: #fff;

	$EuViews: #00a79d;
	$Immigration: #3183b1;
	$Trade: #bb9764;
	$Russia: #27aae1;
	$Nato: #ef4136;
	$China: #fbb040;
	$Development: #812160;
	$EuEnlargement: #6e6e71;
	$Climate: #338f4a;
	$Democracy: #1c4c49;
	$IsraelPalestine: #89684f;
	$active-country: #003a63;

	$roman-normal-book: 'Frutiger Neue LT W06 Book', Arial, sans-serif;
	$roman-italic-book: 'Frutiger Neue LT W06 Book It', Arial, sans-serif;
	$roman-normal-bold: 'Frutiger Neue LT W06 Bold', 'Arial Black', Gadget, sans-serif;

	@mixin all-transition($time) {
		transition: all $time;
		-webkit-transition: all $time;
	}

	/*layout basics*/
	.foreground {
		position: relative;
		margin: 0 auto;
		box-sizing: content-box;
		max-width: $site-width;
		padding-left: calc($gutter / 2);
		padding-right: calc($gutter / 2);
	}

	.section {
		display: block;
		clear: both;
		margin-top: $gutter;
		margin-bottom: $gutter;
	}

	.gutter-right {
		margin-right: 30px;
	}

	.gutter-left {
		margin-left: 30px;
	}

	.zone-title {
		background-color: $medium-gray;
		margin-top: 80px;
		padding-bottom: 20px;
		h2 {
			color: $primary-dark-blue;
			font-family: $roman-normal-bold;
			margin: $gutter 0;
			padding: $gutter 0 0 0;
		}
		p {font-family: $roman-normal-book;}
		p em {font-family: $roman-italic-book;}
		:deep(.rich-text p) {max-width: 100% !important}
	}

	.filters {
		font-size: 1rem;
		margin: $gutter auto;
		width: 90%;

		.title {
			background-color: $primary-dark-blue;
			float: left;
			padding: $gutter/2;
			width: auto;

			span {
				color: $white;
				font-family: $roman-normal-bold;
				font-size: 1rem;
				line-height: 0.8em;
			}
		}

		form {
			float: left;
			margin-bottom: 0;

			fieldset {
				margin-bottom: 1rem;
				padding-left: $gutter/2;
				width: 90%;

				label {
					border: 2px solid $white;
					border-radius: .5em;
					color: $white;
					cursor: pointer;
					float: left;
					margin: $gutter/5;
					padding: .5em;

					&#euViews {
						background-color: $EuViews;
						
						&.active, &:hover {
							background-color: $white; 
							border: $EuViews 2px solid;
							color: $EuViews;
						}
					}

					&#immigration {
						background-color: $Immigration;
						
						&.active, &:hover {
							background-color: $white; 
							border: $Immigration 2px solid;
							color: $Immigration;
						}
					};

					&#trade {
						background-color:$Trade;
						
						&.active, &:hover {
							background-color: $white; 
							border: $Trade 2px solid;
							color: $Trade;
						}
					}

					&#russia {
						background-color:$Russia;
						
						&.active, &:hover {
							background-color: $white; 
							border: $Russia 2px solid;
							color: $Russia;
						}
					}


					&#nato {
						background-color: $Nato;
						
						&.active, &:hover {
							background-color: $white; 
							border: $Nato 2px solid;
							color: $Nato;
						}
					}

					&#china {
						background-color: $China;
						
						&.active, &:hover {
							background-color: $white; 
							border: $China 2px solid;
							color: $China;
						}
					}

					&#development {
						background-color: $Development;
						
						&.active, &:hover {
							background-color: $white; 
							border: $Development 2px solid;
							color: $Development;
						}
					}

					&#euEnlargement {
						background-color: $EuEnlargement;
						
						&.active, &:hover {
							background-color: $white; 
							border: $EuEnlargement 2px solid;
							color: $EuEnlargement;
						}
					}

					&#climate {
						background-color: $Climate;
						
						&.active, &:hover {
							background-color: $white; 
							border: $Climate 2px solid;
							color: $Climate;
						}
					}

					&#democracy {
						background-color: $Democracy;
						
						&.active, &:hover {
							background-color: $white; 
							border: $Democracy 2px solid;
							color: $Democracy;
						}
					}

					&#israelPalestine {
						background-color: $IsraelPalestine;
						
						&.active, &:hover {
							background-color: $white; 
							border: $IsraelPalestine 2px solid;
							color: $IsraelPalestine;
						}
					}

					&#default {
						background-color:#5E83AA;
						
						&.active, &:hover {
							background-color: $white; 
							border: #5E83AA 2px solid;
							color:#5E83AA;
						}
					}

					input {display: none}

					span.name {
						font-family: $roman-normal-book;
						font-size: 1.6rem;
					}
				}

			}
		}
	}

	.map {
		background-color: #BFD7E1; //#D4EEF9;
		margin: $gutter 0;
		position: relative;
	}

	#countrySelect {
		position: absolute;
		left: calc(5% + 36px);;
		top: 10px;
		select {
			border: 1px solid #ccc;
  			background: white;
			padding: 10px;
			font-family: $roman-normal-book;
			font-size: 1.5rem;
		}
	}

	:deep(#info) {
		// display: none;

		&.active {
			background-color: rgba(255,255,255,0.8);
			border: 1px solid $black;
			position: absolute;
			display: block;
			width: 20%;
			height: 100%;
			top: 0;
			right: 5%;
			overflow-y: scroll;

			h3 {
				&.default {background-color: #5E83AA;}

				&.euViews {background-color: $EuViews;}

				&.immigration {background-color: $Immigration;}

				&.trade {background-color: $Trade;}

				&.russia {background-color: $Russia;}

				&.nato {background-color: $Nato;}

				&.china {background-color: $China;}

				&.development {background-color: $Development;}

				&.euEnlargement {background-color: $EuEnlargement;}

				&.climate {background-color: $Climate;}

				&.democracy {background-color: $Democracy;}

				&.israelPalestine {background-color: $IsraelPalestine;}

				&.country {background-color: $active-country;}

				color: $white;
				display: block;
				font-family: $roman-normal-bold;
				font-size: 1.5rem;
				margin-bottom: 1em;
				padding: .5em 1.5em .5em 1.5em;
				width: 100%;
			}
			.description {
				font-family: $roman-normal-book;
				font-size: 1.4rem;
				padding: .5em 1.5em;

				p {margin-bottom: 1.5em;}
				strong {display: block;}
			}

		}

		.close-panel {
			color: $white;
			cursor: pointer;
			font-family: $roman-normal-bold;
			font-size: 1.1rem;
			font-weight: normal;
			top: 0;
			left: -1.5em;
			position: absolute;
			text-transform: uppercase;

			&:after {
				border: none;
			}	

			.icon-cancel-circle {
				padding-left: 1em;
			}			
		}
	}

	#chartdiv {
		// border: 1px solid $black;
		background-color: #BFD7E1; //#D4EEF9;
		float: none;
		margin: 0 auto;
		width: 50%;
		height: 550px;
	}

	.learn-more	{
		p, li {font-family: $roman-normal-book; margin-bottom: 1em;}
		.button-big {
			margin: $gutter auto $gutter*4 auto;
			width: 20%;
		}
	}

	@include media-query(tablet) {
		.filters form {
			padding-left: 0;
			fieldset {
				padding-left: 0;
				label {margin: .5em 10px 0 0;}
				label input {display: inline-block;}
			}
		}
		#info {
			&.active {
				width: 30%;
			}
		}
	}

	@include media-query(mobile) {
		#chartdiv {height: 300px;}
		#countrySelect {left: 25%;}

		#info {
			&.active {
				margin: $gutter auto;
				position: relative;
				right: 0;
				width: 90%;
			}
		}

		.learn-more	.button-big {
			width: 60%;
		}
	}
}
</style>
